import { z } from "zod";

export const contractSectionSchema = z.object({
  heading: z.string(),
  body: z.array(z.string()),
});

export const contractVariableInputTypeSchema = z.enum([
  "text",
  "textarea",
  "number",
  "currency",
  "date",
  "boolean",
  "ccaa",
  "address",
]);
export type ContractVariableInputType = z.infer<typeof contractVariableInputTypeSchema>;

export const contractCcaaValueSchema = z.object({
  ccaa: z.string(),
  value: z.string(),
});
export type ContractCcaaValue = z.infer<typeof contractCcaaValueSchema>;

export const contractAddressAutofillTargetSchema = z.object({
  key: z.string(),
  field: z.enum(["postalCode", "municipality", "province", "ccaa"]),
});
export type ContractAddressAutofillTarget = z.infer<typeof contractAddressAutofillTargetSchema>;

export const contractVariableDefinitionSchema = z.object({
  key: z.string(),
  group: z.string(),
  label: z.string(),
  helpText: z.string(),
  inputType: contractVariableInputTypeSchema,
  required: z.boolean(),
  order: z.number(),
  ccaaValues: z.array(contractCcaaValueSchema).optional(),
  autofillTargets: z.array(contractAddressAutofillTargetSchema).optional(),
});
export type ContractVariableDefinition = z.infer<typeof contractVariableDefinitionSchema>;

export const CONTRACT_STATUS_ACTIVE = "active";
export const CONTRACT_STATUS_ARCHIVED = "archived";

export const contractStatusSchema = z.enum([CONTRACT_STATUS_ACTIVE, CONTRACT_STATUS_ARCHIVED]);
export type ContractStatus = z.infer<typeof contractStatusSchema>;

export const contractSummarySchema = z.object({
  id: z.string(),
  businessId: z.string(),
  templateName: z.string(),
  title: z.string(),
  status: contractStatusSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type ContractSummary = z.infer<typeof contractSummarySchema>;

export const contractSchema = contractSummarySchema.extend({
  templateId: z.string().nullable(),
  variableSchema: z.array(contractVariableDefinitionSchema),
  variables: z.record(z.string()),
  sections: z.array(contractSectionSchema),
});

export type Contract = z.infer<typeof contractSchema>;

export const contractTemplateSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  introText: z.string(),
});

export type ContractTemplateSummary = z.infer<typeof contractTemplateSummarySchema>;
